import React, {useState} from 'react';


function Cart({cart, onRemove, onAdd}) {

    
  return   <>
  <h2>Shopping Cart</h2>
  <p>(This doesn't actually work haha)</p>

  <div className="cart">
  {cart.length === 0 && <div>Cart is empty</div>}
        {cart.map((item) => (
          <div key={item.id} className="row">
            <div className="col-2">{item.name}</div>
            <div className="col-2">
              <button onClick={() => onRemove(item)} className="remove">
                -
              </button>{' '}
              <button onClick={() => onAdd(item)} className="add">
                +
              </button>
            </div>

            <div className="col-2 text-right">
              {item.qty} x ${item.cost.toFixed(2)}
            </div>
          </div>
        ))}
  </div>
</>;
}

export default Cart;
